<template>
  <el-col :span="24">
    <div
      class="ma-0"
      v-loading="loading"
      :element-loading-spinner="svg"
      element-loading-svg-view-box="-10, -10, 50, 50"
      element-loading-background="rgba(122, 122, 122, 0.8)"
    >
    <div class="custom-table-design">
      <el-table
        :data="userDataList"
        :fit="true"
        height="300"
        stripe
        @row-click="handleRowClick"
        class="my-2 data-table"
        scrollbar-always-on: false
      >
            <el-table-column
              fixed="left"
              :label="'Operations'"
              :prop="'operations'"
              align="center"
              width="200"
            >
              <template #default="scope">
                <el-tooltip placement="top" effect="light">
                  <template #content>Download PDF</template>
                  <el-button
                    v-if="
                      scope.row.id != null && scope.row.id != ''
                      "
                      class="height-25 rounded-2 m-0 ml-2"
                      @click.stop="downloadPDF(scope.row.id)"
                      size="small"
                      color="#DDF0AC"
                      style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                      
                      >
                      <svg style="width: 24px; height: 24px;">
                          <use href="@/assets/svg/newSvgIcon.svg#tableOperationDownload"></use>
                      </svg>
                    
                  </el-button>
                </el-tooltip>

                <el-tooltip placement="top" effect="light">
                  <template #content>More Info</template>
                  <el-button
                    v-if="
                      scope.row.id != null && scope.row.id != ''
                    "
                    @click.stop="viewMore(scope.row.id)"
                    size="small"
                    class="height-25 rounded-2 m-0 ml-2"
                    color="#DDF0AC"
                    style="width: 25px; height: 25px; padding: 0px; align-items: center;"
                  >
                      <svg style="width: 24px; height: 24px;">
                          <use href="@/assets/svg/newSvgIcon.svg#tableOperationMoreInfo"></use>
                      </svg>
                  </el-button>
                </el-tooltip>

              </template>
            </el-table-column>
        <el-table-column
          :label="'ID'"
          :prop="'id'"
          :width="$vuetify.display.width <= 2120 ? 150 : ''"
          sortable
        />
        <el-table-column
          :label="'Project ID'"
          :prop="'projectId'"
          :width="$vuetify.display.width <= 2120 ? 150 : ''"
          sortable
        />
        <el-table-column
          :label="'Standard Template'"
          :prop="'standardTemplate'"
          :width="$vuetify.display.width <= 2120 ? 200 : ''"
          sortable
        />
        <el-table-column
          :label="'Standard Template Name'"
          :prop="'standardTemplateName'"
          :width="$vuetify.display.width <= 2120 ? 230 : ''"
          sortable
        />
        <el-table-column
          :label="'Methodology Template'"
          :prop="'methodologyTemplate'"
          :width="$vuetify.display.width <= 2120 ? 230 : ''"
          sortable
        />
        <el-table-column
          :label="'Monitoring Report Name'"
          :prop="'monitoringReportName'"
          :width="$vuetify.display.width <= 2120 ? 230 : ''"
          sortable
        />
        <el-table-column
          :label="'Project Name'"
          :prop="'projectName'"
          :width="$vuetify.display.width <= 2120 ? 210 : ''"
          sortable
        />
        <el-table-column
          :label="'Submission Status'"
          :prop="'submissionStatus'"
          :width="$vuetify.display.width <= 2120 ? 210 : ''"
          sortable
        />
      </el-table>
    </div>

      <div class="custom-pagination" v-if="$vuetify.display.width >= 700">
        <el-row class="row-bg" justify="space-between">
          <el-col
            :span="5"
            class="d-flex justify-content-start align-items-center"
          >
            <el-select
              v-model="perPageCount"
              placeholder="Select"
              size="small"
              style="width: 70px"
            >
                        <el-option label="10" :value="'10'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <el-option label="500" :value="'500'" />
                        <el-option label="1k" :value="'1000'" />
            </el-select>
          </el-col>
          <el-col
            :span="8"
            class="d-flex align-items-center justify-content-center"
          >
            <el-pagination
              small
              background
              layout="prev, pager, next"
              :total="total_items"
              v-model:page-size="page_size"
              v-model:current-page="current_page"
              @current-change="changePage"
              class="my-4"
            />
          </el-col>
          <el-col :span="5" class="d-flex justify-content-end align-items-center">
            <span class="text-white">
              {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                current_page * perPageCount > total_items
                  ? total_items.toLocaleString()
                  : (current_page * perPageCount).toLocaleString()
              }}
              of {{ total_items.toLocaleString() }}
            </span>
          </el-col>
        </el-row>
      </div>

      <div class="custom-pagination" v-if="$vuetify.display.width < 700">
        <el-row class="row-bg" justify="space-between">
          <el-col
            :span="24"
            class="d-flex align-items-center justify-content-center"
          >
            <el-pagination
              small
              background
              layout="prev, pager, next"
              :total="total_items"
              v-model:page-size="page_size"
              v-model:current-page="current_page"
              @current-change="changePage"
              class="my-4"
            />
          </el-col>
          <el-col
            :span="10"
            class="d-flex justify-content-end align-items-center"
          >
            <el-select
              v-model="perPageCount"
              placeholder="Select"
              size="small"
              style="width: 70px"
            >
                        <el-option label="10" :value="'10'" />
                        <el-option label="25" :value="'25'" />
                        <el-option label="50" :value="'50'" />
                        <el-option label="100" :value="'100'" />
                        <el-option label="500" :value="'500'" />
                        <el-option label="1k" :value="'1000'" />
            </el-select>
          </el-col>

          <el-col :span="10" class="d-flex justify-content-start align-items-center">
            <span class="text-white">
              {{ ((current_page - 1) * perPageCount + 1).toLocaleString() }}-{{
                current_page * perPageCount > total_items
                  ? total_items.toLocaleString()
                  : (current_page * perPageCount).toLocaleString()
              }}
              of {{ total_items.toLocaleString() }}
            </span>
          </el-col>
        </el-row>
      </div>

    </div>
  </el-col>
</template>

<script>
// import { ElMessageBox } from "element-plus";
// import ShowDetail from "./dialogDetail.vue";
import userService from '@/services/user.service';
import { convertBase64ToPDF, createLoadingInstance } from '@/pages/dashboard/common/common-tools';
import { ElMessageBox } from 'element-plus';
export default {
  props: {
    loadingProp: {
      type: Boolean,
      default: false,
    },
    usersDataProp: {
      type: Array,
      default(rawProps) {
        return rawProps;
      },
    },
    totalRowProp: {
      type: Number,
    },
  },
  components: {
    // ShowDetail,
  },
  data() {
    return {
      show: true,
      userDataList: [],
      search: "",
      current_page: 1,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,
      loading: false,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      filterOpen: false,
    };
  },
  watch: {
    loadingProp: {
      handler: function (newValue) {
        this.loading = newValue;
      },
      deep: true,
    },
    usersDataProp: {
      handler: function (newValue) {
        this.userDataList = newValue;
        this.total_items = newValue.length;
      },
      deep: true,
    },
    totalRowProp: {
      handler: function (newValue) {
        this.current_page = 1;
        this.total_items = newValue;
        console.log(this.total_items);
      },
      deep: true,
    },
    perPageCount: function (newVal) {
      this.current_page = 1;
      this.page_size = parseInt(newVal);
      this.$emit("tableAction", {
        index: this.page_size,
        data: null,
        kind: "perPageChange",
      });
    },
  },
  methods: {
    handleRowClick(row, column, event) {
      console.log(row, column, event);
    },
    changePage(page) {
      this.$emit("tableAction", {
        index: page,
        data: null,
        kind: "changePage",
      });
    },

    async downloadPDF(verra_mp_id) {
      console.log("id of selected row",verra_mp_id);
      const loadingInstance = createLoadingInstance("Downloading PDF...");
      await userService.verraTableAction(verra_mp_id, 'pdf').then(response => {
        let pdfData = response.data.pdf_data;
        let filename = response.data.filename;
        convertBase64ToPDF(pdfData, filename);
        loadingInstance.close();
      }).catch(error => {
        loadingInstance.close();
        console.error('Error in download PDF:', error.message);
        let MessageBox = `
          <div>
            <span class="moderat-meGreen-bold">Error in download PDF:</span><br>
            <span class="moderat-meGreen">${error.response.data.message}</span>
          </div>
        `;

        ElMessageBox.alert(MessageBox, {
          confirmButtonText: "OK",
          type: "error",
          dangerouslyUseHTMLString: true,
          customClass: 'error-details-messagebox'
        }).then(()=> {return;}).catch(()=>{return;});

      });
    },
    async viewMore(verra_mp_id) {
      console.log("id of selected row",verra_mp_id);
      const loadingInstance = createLoadingInstance("Loading data...");
      await userService.verraTableAction(verra_mp_id, 'view-more').then(response => {
        loadingInstance.close();
        this.$emit("tableAction", { data: response.data, kind: "viewMore" });
      }).catch(error => {
        loadingInstance.close();
        console.error('Error in get view more data:', error.message);

        let MessageBox = `
          <div>
            <span class="moderat-meGreen-bold">An error occurred while fetching more data.</span><br>
            <span class="moderat-meGreen">${error.response.data.message}</span>
          </div>
        `;

        ElMessageBox.alert(MessageBox, {
          confirmButtonText: "OK",
          type: "error",
          dangerouslyUseHTMLString: true,
          customClass: 'error-details-messagebox'
        }).then(()=> {return;}).catch(()=>{return;});
      });
    },

  },
};
</script>


